/**
 * Premium smooth scroll, powered by Lenis (assets/lenis.min.js, loaded just before this file).
 *
 * Lenis drives native `window.scrollTo` under the hood rather than a transform/virtual-scroll
 * approach, so position:sticky, scroll listeners elsewhere in the theme (header, reveal
 * animations, infinite scroll), and anchor jumps all keep working as before. `syncTouch` is
 * left off (default), so touch devices keep 100% native scroll physics; smoothing only
 * applies to desktop mouse/trackpad wheel input.
 */
(function () {
  "use strict";

  var lenis = null;

  /* Overlays nest - a quick-cart popup opens over the shoppable-video
     player - so parking Lenis is counted rather than toggled. Without the
     count, closing the inner overlay hands scrolling back while the outer
     one is still open and the page drifts behind it.

     Defined before the bails below so the callers can park unconditionally:
     with no Lenis running there is nothing to park, and these no-op. */
  var parkDepth = 0;

  window.lenisPark = function () {
    parkDepth += 1;

    if (parkDepth === 1 && lenis) lenis.stop();
  };

  window.lenisUnpark = function () {
    if (parkDepth === 0) return;

    parkDepth -= 1;

    // start() resets Lenis to the real scroll position, so nothing jumps.
    if (parkDepth === 0 && lenis) lenis.start();
  };

  if (typeof Lenis === "undefined") return;
  if (
    !window.matchMedia ||
    !window.matchMedia("(hover: hover) and (pointer: fine)").matches
  )
    return;

  // Lets any inner scrollable region (cart drawer, modal, dropdown, mega menu) scroll
  // natively instead of being smoothed by Lenis, as long as it can still absorb the delta.
  function isInsideScrollable(node) {
    var overflowY = window.getComputedStyle(node).overflowY;
    return (
      (overflowY === "auto" || overflowY === "scroll") &&
      node.scrollHeight > node.clientHeight
    );
  }

  // Lenis's own default lerp (0.06) is the well-tested baseline; nudged slightly lower
  // for a touch more glide per user feedback, without tipping into floaty/laggy territory.
  lenis = new Lenis({
    lerp: 0.06,
    autoRaf: true,
    prevent: isInsideScrollable,
  });

  window.lenisInstance = lenis;

  /* Opened before Lenis finished booting: honour the park it missed. */
  if (parkDepth > 0) lenis.stop();
})();
